export default "__VITE_ASSET__C6vlU0M$__"